// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"833":"809079a98e914425","964":"96f1966bbbd4bcb9"}[chunkId] + ".js";
};